import { authSlice } from "./store/auth.slice";
import { authApi, useLoginMutation, useLazyGetProfileQuery, useGetProfileQuery } from "./api/auth.api";
import { ILoginFormValues } from './types'

export const { logout, setUser, setToken } = authSlice.actions;

export type { ILoginFormValues }

export { authApi, useLazyGetProfileQuery, authSlice, useLoginMutation, useGetProfileQuery };
